// 必要なコンポーネントやライブラリをインポート
import UserFrame from "../organisms/UserFrame"; // ユーザー用のフレームコンポーネント
import UHSlides from "../organisms/UHSlides"; // スライドショーコンポーネント
import UHNavigation from '../organisms/UHNavigation'; // ナビゲーションメニューバーコンポーネント
import UHInformation from '../organisms/UHInformation'; // お知らせ情報表示コンポーネント
import { Box } from "@mui/material"; // Material-UIのボックスレイアウトコンポーネント
import { useEffect } from "react"; // ReactのuseEffectを使用

/** 
 * ブラウザの戻るボタンを無効化するコンポーネント
 */
export const PreventBackButton = () => {
    useEffect(() => {
        // ページを開いた際に履歴を上書き
        window.history.pushState(null, "", window.location.href);

        const handlePopState = () => {
            console.log("戻るボタンが押されました");

            // ユーザーが戻るボタンを押したら、もう一度同じURLに戻す
            window.history.pushState(null, "", window.location.href);
            
            // 必要なら、強制的にリダイレクト
            window.location.replace(window.location.href);
        };

        // popstate イベントを監視し、戻るボタンを無効化
        window.addEventListener("popstate", handlePopState);

        return () => {
            // コンポーネントがアンマウントされたときにイベントリスナーを削除
            window.removeEventListener("popstate", handlePopState);
        };
    }, []);

    return null;
};

/** 
 * ユーザーホームテンプレートコンポーネント
 * ホーム画面を構築するためのUIを提供
 */
const UserHomeTemplate = () => {

    return (
        // ユーザー専用フレームで全体をラップ
        <UserFrame title=''> {/* タイトルは空の状態 */}
            <Box>
                {/* スライドショーコンポーネントを表示 */}
                <Box sx={{
                    marginTop: '10px', // 上部のマージンをマイナスで調整
                    maxHeight: '42vh',
                    display: 'flex', // フレックスボックスを使用
                    justifyContent: 'center', // 水平方向に中央寄せ
                    alignItems: 'center' // 垂直方向に中央寄せ
                }}>
                    <UHSlides /> {/* スライドショーコンポーネント */}
                </Box>
                {/* ナビゲーションメニュー */}
                <UHNavigation />
                {/* お知らせ情報セクション */}
                <UHInformation />
            </Box>
        </UserFrame>
    )
}

// コンポーネントをエクスポート
export default UserHomeTemplate;
